import * as yup from 'yup';
import { PROJECT_TYPES } from '../../../constants';

export const projectRequestFormYupValidation = () => {
  return yup.object().shape({
    projectType: yup.string().required('required'),

    name: yup.string().required('required'),
    email: yup.string().email('invalidEmail').required('required'),

    users: yup.string(),

    supplementaryInfo: yup.string(),

    relevantUrl: yup.string().when('projectType', {
      is: PROJECT_TYPES.SONAR,
      then: (schema) => schema.required('required'),
      otherwise: (schema) => schema.optional(),
    }),
    relevantCompetitorsUrls: yup.string().when('projectType', {
      is: PROJECT_TYPES.SONAR,
      then: (schema) => schema.optional(),
      otherwise: (schema) => schema.optional(),
    }),
  });
};
